import { forwardRef, memo, useLayoutEffect } from 'react';
import { useRenderColumns } from '../../columns';
import { ComparisonTableCarousel, Table } from '../components';
import { useLayout } from '../layout-context';

export const LayoutComparisonTable = memo(
  forwardRef<HTMLDivElement, unknown>((_, ref) => {
    const columnElements = useRenderColumns();
    const {
      breakpoints: { isMediumBreakpoint, overflows },
      setLayout
    } = useLayout();

    useLayoutEffect(() => {
      if (isMediumBreakpoint) {
        setLayout('comparisonTableMobile');
      }
    }, [isMediumBreakpoint, setLayout]);

    if (overflows) {
      return (
        <ComparisonTableCarousel ref={ref}>
          {columnElements}
        </ComparisonTableCarousel>
      );
    }

    return (
      <Table ref={ref} component="layout-comparison-table">
        {columnElements}
      </Table>
    );
  })
);
